import React from 'react'
import AssessmentFlow from '@/components/freetool/AssessmentFlow'
import { asrsQuestions, responseOptions } from '@/data/adhdQuestions'

type Props = {
  backHref?: string
}

const ADHDApp: React.FC<Props> = ({ backHref }) => {
  return (
    <AssessmentFlow
      kind="adhd"
      title="Attention Deficit Hyperactivity Disorder Assessment Tool"
      sublabel="Based on the Adult ADHD Self-Report Scale (ASRS)"
      questions={asrsQuestions}
      options={responseOptions}
      gridClass="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2"
      badgeClass="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-blue-500 text-white text-xs sm:text-sm font-bold"
      theme={{ from: 'from-blue-600', to: 'to-purple-600', dot: 'bg-blue-600' }}
      pdfLogoUrl="/logos/black-horizontal-logo.png"
      backHref={backHref ?? '/adhd-autism-assessment-tool'}
    />
  )
}

export default ADHDApp
